module.exports = __webpack_public_path__ + "img/2.eb1f0c68.png";